let deferredPrompt;

window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;

    // Store globally (PwaBanner can access it)
    window.pwaInstallEvent = event;

    /*
        Opera (desktop version) doesn't support PWA / WebApps.
     */
    const isOpera = !!navigator.userAgent.match(/Opera|OPR\//);
    if (!isOpera) {
        listenInstallButtonClick();
    }
});

function listenInstallButtonClick() {
    if (!deferredPrompt) {
        return;
    }

    const installButtons = document.querySelectorAll('.install-button');
    if (installButtons?.length > 0) {
        installButtons.forEach((button) => {
            button.style.display = 'inline-block';

            button.addEventListener('click', addSiteToBrowserHomepage);
        });
    }
}

function addSiteToBrowserHomepage() {
    deferredPrompt.prompt();
}

window.addEventListener('appinstalled', () => {
    const installButtons = document.querySelectorAll('.install-button');
    if (installButtons?.length > 0) {
        installButtons.forEach((button) => {
            button.remove();
        });
    }
    deferredPrompt = null;
    window.pwaInstallEvent = null;
});
